import React, { useState } from "react";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { mainPageItemNameDescriptionLanguageVersion, metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import { Link } from "react-router-dom";


const MNPG008 = (props: TMainPageLayoutV2) => {
    console.log("MNPG008.rendered", props);

    const [languageVersion] = useState(mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions));

    const [contactUs] = useState(props.templates?.find((item) => item.parentId === props.template?.id));
    const [address] = useState(metaDataLanguageVersion("address", contactUs?.languageVersions));
    const [mapURL] = useState(metaDataLanguageVersion("mapURL", contactUs?.languageVersions));
    const [phone] = useState(metaDataLanguageVersion("phone", contactUs?.languageVersions));
    const [email] = useState(metaDataLanguageVersion("email", contactUs?.languageVersions));
    const [workingHours] = useState(metaDataLanguageVersion("workingHours", contactUs?.languageVersions));
    console.log("mapURL: ", mapURL);

    if ( !props.template ) return null;

    return (
        <div
            className="col-xl-3 col-md-6 "
            data-aos-duration="800"
            data-aos="fade-up"
            data-aos-delay="700"
        >
            <div className="single-footer-widget">
                <div className="widget-head">
                    <h3>{languageVersion?.name}</h3>
                </div>
                <div className="footer-content">
                    <ul className="contact-info">
                        <li>
                            <i className="fas fa-map-marker-alt"></i>
                            <Link to={mapURL} aria-label="address">{address}</Link>
                        </li>
                        <li>
                            <i className="fa-solid fa-phone-volume"></i>
                            <Link to={`tel:${phone?.trim()?.replace(/[^0-9]/g, "")}`} aria-label="phone">
                                {phone}
                            </Link>
                        </li>
                        <li>
                            <i className="fa-regular fa-envelope"></i>
                            <Link to={`mailto:${email}`} aria-label="email">
                                {email}
                            </Link>
                        </li>
                        <li>
                            <i className="fa-regular fa-clock"></i>
                            {workingHours}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG008, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG008.memo", { prevProps, nextProps });
    return true;
});

export default Component;
